"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_core_1 = require("@patternfly/react-core");
var react_table_1 = require("@patternfly/react-table");
function ZIBasicTable(props) {
    return ((0, jsx_runtime_1.jsx)(react_core_1.Grid, __assign({ hasGutter: true }, { children: (0, jsx_runtime_1.jsx)(react_core_1.GridItem, __assign({ span: 12 }, { children: (0, jsx_runtime_1.jsxs)(react_table_1.Table, __assign({ "aria-label": props.ariaLabel, actions: props.actions, sortBy: props.sortBy, onSort: props.onSort, cells: props.columns, rows: props.rows }, { children: [(0, jsx_runtime_1.jsx)(react_table_1.TableHeader, {}), (0, jsx_runtime_1.jsx)(react_table_1.TableBody, {})] })) })) })));
}
exports.default = ZIBasicTable;
